import { apiSlice } from "../api/apiSlice";

export const projectsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getBacklogData: builder.query({
            query: () => "/BacklogData",
            providesTags: ["BacklogDatas"],
        }),
        getReadyData: builder.query({
            query: () => "/ReadyData",
            providesTags: ["ReadyDatas"],
        }),
        getDoingData: builder.query({
            query: () => "/DoingData",
            providesTags: ["DoingDatas"],
        }),
        getReviewData: builder.query({
            query: () => "/ReviewData",
            providesTags: ["ReviewDatas"],
        }),
        getBlockedData: builder.query({
            query: () => "/BlockedData",
            providesTags: ["BlockedDatas"],
        }),
        getDoneData: builder.query({
            query: () => "/DoneData",
            providesTags: ["DoneDatas"],
        }),
        createProject: builder.mutation({
            query: (data) => ({
                url: "/BacklogData",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["BacklogDatas"],
        }),
        deleteBacklog: builder.mutation({
            query: (id) => ({
                url: `/BacklogData/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["BacklogDatas"],
        }),
    }),
});

export const {
    useGetProjectsQuery,
    useCreateProjectMutation,
    useGetBacklogDataQuery,
    useDeleteBacklogMutation,
    useGetReadyDataQuery,
    useGetDoingDataQuery,
    useGetReviewDataQuery,
    useGetBlockedDataQuery,
    useGetDoneDataQuery,
} = projectsApi;
